import { useState } from 'react'
import { Dropdown } from 'antd'
import cn from 'classnames'
import { MenuItems } from './MenuItems'
import { TMenu } from './types'
import { ReactComponent as ThreeDots } from 'assets/svg/Dots24.svg'

export const HospitalMenu = ({
  row,
  setOpenArchivePopup,
  handleSelectRow,
  setOpenActivatePopup,
  hsId
}: TMenu) => {
  const [visible, setVisible] = useState(false)
  return (
    <Dropdown
      onVisibleChange={() => setVisible(!visible)}
      visible={visible}
      className="menu-items"
      overlay={
        <MenuItems
          setVisible={setVisible}
          row={row}
          hsId={hsId}
          setOpenArchivePopup={setOpenArchivePopup}
          setOpenActivatePopup={setOpenActivatePopup}
          handleSelectRow={handleSelectRow}
        />
      }
      placement="bottomRight"
      trigger={['click']}
    >
      <div className={cn('dots-items')} onClick={(e) => e.stopPropagation()}>
        <ThreeDots />
      </div>
    </Dropdown>
  )
}
